<app-dropdown [closeTrigger]="closeTrigger" [direction]="direction" [type]="type">
  <ng-content ngProjectAs=".dropdown-toggle"></ng-content>
  <div class="dropdown-content" id="dropdown-content">
    @if (dropdownTitle) {
      <div class="dropdown-item dropdown-title">{{ dropdownTitle }}</div>
    }
    @if (emptyIncluded) {
      <div class="dropdown-item placeholder" (click)="selectValue(null)">{{ emptyLabel }}</div>
    }
    @for (value of values; track value) {
      <div class="dropdown-item" [appIsEnabled]="$any(value).permission" (click)="selectValue(value)">
        {{ $any(value).label }}
      </div>
    }
    @if (hasDaterangePicker) {
      <div
        class="dropdown-item"
        appDateRangeWrapper
        [initialDaterange]="$any(selectedCustomRange)"
        [currentDaterange]="$any(selectedCustomRange)"
        [options]="dateRangePickerConfig"
        (selected)="selectCustomRange($event)"
      >
        Custom date range
      </div>
    }
  </div>
</app-dropdown>
